import Vue from 'vue';
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
export default Vue.extend({
    props: {
        input: Object
    },
    data: function () {
        return {
            fp: null,
            value: this.input.value,
        };
    },
    mounted: function () {
        var options = {
            allowInput: true,
            dateFormat: 'd.m.Y',
            locale: this.$helpers.locale() == 'de' ? German : 'default',
        };
        if (this.input.subtype == 'datetime-local') {
            options.enableTime = true;
            options.time_24hr = true;
            options.dateFormat = 'd.m.Y H:i';
        }
        this.fp = flatpickr(this.$refs.input, options);
    }
});
